import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supportKeys } from '@/features/org/queries';
import { api } from '@/lib/api';

export const supportThreadKeys = {
  request: (id: string) => ['support', 'request', id] as const,
  messages: (id: string) => ['support', 'messages', id] as const,
  mine: ['support', 'mine'] as const,
};

export function useSupportRequest(id: string) {
  return useQuery({ queryKey: supportThreadKeys.request(id), queryFn: () => api.support.get(id), enabled: !!id });
}

export function useSupportMessages(id: string) {
  return useQuery({ queryKey: supportThreadKeys.messages(id), queryFn: () => api.support.messages(id), enabled: !!id, refetchInterval: 30_000 });
}

export function useMyRequests() {
  return useQuery({ queryKey: supportThreadKeys.mine, queryFn: () => api.support.mine() });
}

/** Post a reply (optionally internal, optionally with image attachments) and refresh the thread and lists. */
export function useReplyToRequest(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { body: string; internal?: boolean; files?: File[] }) => api.support.reply(id, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: supportThreadKeys.messages(id) });
      void qc.invalidateQueries({ queryKey: supportThreadKeys.request(id) });
      void qc.invalidateQueries({ queryKey: supportThreadKeys.mine });
      void qc.invalidateQueries({ queryKey: supportKeys.all });
    },
  });
}
